import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalKendo} from "../../lib/ModalKendo";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {CadGrupoInsumoComponent} from "../cad-grupo-insumo/cad-grupo-insumo.component";
import {NgForm} from "@angular/forms";
import {EstoqueService} from "../../services/estoque.service";
import {UnidadeMedidaUtils} from "../UnidadeMedidaUtils";
import {
  TelaHistoricoMovimentacoesComponent
} from "../tela-historico-movimentacoes/tela-historico-movimentacoes.component";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {PreparadorEstoqueInicial} from "./PreparadorEstoqueInicial";
import {
  CadApresentacaoCompraComponent
} from "../cad-apresentacao-compra/cad-apresentacao-compra.component";
import {
  CadVinculoFornecimentoItemComponent
} from "../cad-vinculo-fornecimento-item/cad-vinculo-fornecimento-item.component";

@Component({
  selector: 'app-cad-insumo',
  templateUrl: './cad-insumo.component.html',
  styleUrls: ['./cad-insumo.component.scss']
})
export class CadInsumoComponent   extends ModalKendo implements OnInit {
  @ViewChild('frm', {static: false}) frm: NgForm;
  @ViewChild('frmFicha', {static: false}) frmFicha: NgForm;
  @ViewChild('telaMovimentacoes', {static: false}) telaMovimentacoes: TelaHistoricoMovimentacoesComponent;
  usuarioLogado: any;
  insumo: any = {  estoque: { quantidade: 0, quantidadeMinima: 1}, totalVinculos: 0, precoDeCusto: 0};
  abaSelecionada  = 1;
  empresa: any = {};
  unidades = [];
  mensagemSucesso: any;
  mensagemErro: string;
  grupos = [];
  salvando = false;
  novaMovimentacao: any;
  controleCustoEstoqueAtivo = false;
  carregandoStatusControleCusto = true;
  fonteCustoInicial: 'unitario' | 'total' = 'unitario';
  apresentacoesGlobais: any[] = [];
  apresentacoesCompra: any[] = [];
  fornecimentoConfigurado = false;
  apresentacaoEditando: any;
  carregandoApresentacoes = false;
  salvandoApresentacao = false;
  removendoVinculoApresentacaoId: number;
  mensagemErroApresentacao: string;
  mensagemSucessoApresentacao: string;

  FICHA_PRODUTO_VENDA  = 'produto-venda';
  FICHA_PRODUTO_BENEFICIADO  = 'produto-beneficiado';
  constructor( private dialogService: DialogService,  private estoqueService: EstoqueService,
               private autorizacaoService: AutorizacaoService,
               private constantsService: ConstantsService) {

    super()
  }

  static abraModalInsumo(dialogService: any, grupos: any, insumo: any = null, aba = null, fichaTecnica: boolean = null,
                         fnSalvou: any = null, iniciarEntradaPorBeneficiamento = false) {
    //scrollable: true
    const windowRef: DialogRef = dialogService.open({
      content: CadInsumoComponent,
      minWidth: 250,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      cssClass: 'bsModal',
      maxHeight:  window.innerHeight - 100

    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.grupos = grupos;

    if(insumo)     windowRef.content.instance.insumo = insumo;
    if(aba)        windowRef.content.instance.abaSelecionada = aba

    if(iniciarEntradaPorBeneficiamento)
      windowRef.content.instance.novaMovimentacao = {
        horario: new Date(),
        insumo: windowRef.content.instance.insumo,
        motivoDaMovimentacao: {
          id: 3,
          descricao: 'Entrada por beneficiamento',
          tipo: 'entrada',
          paraInsumoBeneficado: true
        }
      };

    if(fichaTecnica)
      windowRef.content.instance.insumo.fichaTecnica = true;

    windowRef.result.subscribe( (result: any) => {
        if(fnSalvou && result && result.salvou)
          fnSalvou(result);
      },
      (a) => {      });
  }


  ngOnInit(): void {

    this.estoqueService.obtenhaStatusControleCustoEstoque().then((status: any) => {
      this.controleCustoEstoqueAtivo = !!status.ativo;
      this.carregandoStatusControleCusto = false;
      if(this.controleCustoEstoqueAtivo && !this.insumo.estoque)
        this.insumo.estoque = {quantidade: 0, quantidadeMinima: 1};
      if(this.insumo.estoque && this.insumo.estoque.custoTotalInicial != null)
        this.fonteCustoInicial = 'total';
    }).catch((erro: any) => {
      this.carregandoStatusControleCusto = false;
      this.mensagemErro = erro;
    });

    this.estoqueService.listeUnidades().then( (unidades: any) => {
      this.unidades = unidades;
      if(this.insumo.unidadeMedida)
        this.insumo.unidadeMedida = this.unidades.find( unidade => unidade.id === this.insumo.unidadeMedida.id );
      else
        this.insumo.unidadeMedida = unidades.find((item: any) => item.sigla === 'und');

      if(this.insumo.grupo)
        this.insumo.grupo = this.grupos.find((item: any) => item.id ===      this.insumo.grupo.id)
    });


    if(this.insumo.fichaTecnica && !this.insumo.receita){
      this.insumo.receita = {
        ingredientes: []
      }
      //receitas via regra tem no minimo 2 indredientes
      this.novoIngrediente();
      this.novoIngrediente();
    }
    this.usuarioLogado = this.autorizacaoService.getUser();

    if(this.deveExibirApresentacoes())
      this.carregueApresentacoes();
  }

  deveExibirApresentacoes(): boolean {
    return !!this.insumo.id && !this.insumo.fichaTecnica && this.insumo.objeto !== 'ficha-tecnica';
  }

  carregueApresentacoes(): void {
    this.carregandoApresentacoes = true;
    this.mensagemErroApresentacao = null;
    Promise.all([
      this.estoqueService.listeApresentacoesCompraGlobais({
        somenteAtivas: true,
        unidadeMedidaId: Number(this.insumo.unidadeMedida.id)
      }),
      this.estoqueService.listeApresentacoesCompra(Number(this.insumo.id)),
      this.estoqueService.obtenhaCatalogoComprasInternas()
    ]).then((resultados: any[]) => {
      this.apresentacoesGlobais = resultados[0] || [];
      this.apresentacoesCompra = resultados[1] || [];
      this.fornecimentoConfigurado = !!(resultados[2] && resultados[2].fornecimento);
      this.apliqueCorrespondencias(resultados[2]);
      this.carregandoApresentacoes = false;
    }).catch((erro: any) => {
      this.mensagemErroApresentacao = erro;
      this.carregandoApresentacoes = false;
    });
  }

  vinculeApresentacaoCadastrada(): void {
    this.apresentacaoEditando = {
      apresentacaoCompra: null,
      codigoFornecedor: null,
      padrao: false,
      ativa: true
    };
    this.limpeMensagensApresentacao();
  }

  novaApresentacao(): void {
    this.limpeMensagensApresentacao();
    const windowRef: DialogRef = CadApresentacaoCompraComponent.abraModal(
      this.dialogService,
      null,
      this.insumo.unidadeMedida
    );
    windowRef.result.subscribe((apresentacao: any) => {
      if(apresentacao && apresentacao.id)
        this.vinculeNovaApresentacao(apresentacao);
    });
  }

  editeApresentacao(apresentacao: any): void {
    this.apresentacaoEditando = Object.assign({}, apresentacao);
    this.limpeMensagensApresentacao();
  }

  configureDePara(apresentacao: any): void {
    const windowRef = CadVinculoFornecimentoItemComponent.abraModal(
      this.dialogService,
      apresentacao,
      this.insumo
    );
    windowRef.result.subscribe((resultado: any) => {
      if(resultado && resultado.alterado)
        this.carregueApresentacoes();
    });
  }

  rotuloCorrespondencia(apresentacao: any): string {
    if(!apresentacao.ativa)
      return 'Indisponível';
    const status = apresentacao.correspondencia && apresentacao.correspondencia.status;
    return {
      VINCULADO: 'Vinculado',
      PENDENTE: 'Pendente',
      AMBIGUO: 'Ambíguo',
      INCOMPATIVEL: 'Incompatível'
    }[status] || 'Pendente';
  }

  classeCorrespondencia(apresentacao: any): string {
    if(!apresentacao.ativa)
      return 'badge-secondary';
    const status = apresentacao.correspondencia && apresentacao.correspondencia.status;
    return {
      VINCULADO: 'badge-success',
      PENDENTE: 'badge-warning',
      AMBIGUO: 'badge-info',
      INCOMPATIVEL: 'badge-danger'
    }[status] || 'badge-warning';
  }

  canceleEdicaoApresentacao(): void {
    this.apresentacaoEditando = null;
  }

  salveApresentacao(): void {
    if(this.salvandoApresentacao || !this.apresentacaoValida())
      return;
    this.salvandoApresentacao = true;
    this.limpeMensagensApresentacao();
    this.estoqueService.salveApresentacaoCompra(
      Number(this.insumo.id),
      this.apresentacaoEditando
    ).then((salva: any) => {
      const indice = this.apresentacoesCompra.findIndex(
        item => Number(item.id) === Number(salva.id)
      );
      if(indice >= 0)
        this.apresentacoesCompra[indice] = salva;
      else
        this.apresentacoesCompra.push(salva);
      if(salva.padrao){
        this.apresentacoesCompra.forEach(item => {
          if(Number(item.id) !== Number(salva.id))
            item.padrao = false;
        });
      }
      this.ordeneApresentacoes();
      this.apresentacaoEditando = null;
      this.salvandoApresentacao = false;
      this.mensagemSucessoApresentacao = 'Unidade de compra salva com sucesso.';
      this.carregueApresentacoes();
    }).catch((erro: any) => {
      this.mensagemErroApresentacao = erro;
      this.salvandoApresentacao = false;
    });
  }

  removaVinculoApresentacao(apresentacao: any): void {
    if(!apresentacao || !apresentacao.id || this.removendoVinculoApresentacaoId)
      return;
    this.removendoVinculoApresentacaoId = Number(apresentacao.id);
    this.limpeMensagensApresentacao();
    this.estoqueService.removaVinculoApresentacaoCompra(
      Number(this.insumo.id),
      Number(apresentacao.id)
    ).then(() => {
      this.apresentacoesCompra = this.apresentacoesCompra.filter(
        item => Number(item.id) !== Number(apresentacao.id)
      );
      this.removendoVinculoApresentacaoId = null;
      this.mensagemSucessoApresentacao = 'Vínculo com a unidade de compra removido com sucesso.';
    }).catch((erro: any) => {
      this.removendoVinculoApresentacaoId = null;
      this.mensagemErroApresentacao = erro;
    });
  }

  apresentacaoValida(): boolean {
    const item = this.apresentacaoEditando;
    return !!item && (!!item.id || !!(item.apresentacaoCompra && item.apresentacaoCompra.id));
  }

  apresentacoesGlobaisDisponiveis(): any[] {
    const idsVinculados = new Set(this.apresentacoesCompra.map(item =>
      Number(item.apresentacaoCompra && item.apresentacaoCompra.id)
    ));
    return this.apresentacoesGlobais.filter(item => !idsVinculados.has(Number(item.id)));
  }

  resultadoVisualApresentacao(apresentacao: any): string {
    const definicao = apresentacao && apresentacao.apresentacaoCompra || apresentacao;
    const fator = definicao && definicao.fatorConversao;
    if(fator == null)
      return '';
    const sigla = this.insumo && this.insumo.unidadeMedida
      ? this.insumo.unidadeMedida.sigla
      : '';
    return `${this.formateFatorApresentacao(fator)} ${sigla || ''}`.trim();
  }

  private formateFatorApresentacao(valor: any): string {
    const numero = Number(valor);
    if(!Number.isFinite(numero))
      return String(valor || '');
    return numero.toLocaleString('pt-BR', {maximumFractionDigits: 6});
  }

  private ordeneApresentacoes(): void {
    this.apresentacoesCompra = this.apresentacoesCompra.slice().sort((a, b) => {
      if(!!a.ativa !== !!b.ativa)
        return a.ativa ? -1 : 1;
      if(!!a.padrao !== !!b.padrao)
        return a.padrao ? -1 : 1;
      return String(a.apresentacaoCompra && a.apresentacaoCompra.descricao)
        .localeCompare(String(b.apresentacaoCompra && b.apresentacaoCompra.descricao));
    });
  }

  private limpeMensagensApresentacao(): void {
    this.mensagemErroApresentacao = null;
    this.mensagemSucessoApresentacao = null;
  }

  private vinculeNovaApresentacao(apresentacao: any): void {
    this.salvandoApresentacao = true;
    if(!this.apresentacoesGlobais.some(item => Number(item.id) === Number(apresentacao.id)))
      this.apresentacoesGlobais.push(apresentacao);
    this.estoqueService.salveApresentacaoCompra(Number(this.insumo.id), {
      apresentacaoCompra: apresentacao,
      codigoFornecedor: null,
      padrao: false,
      ativa: true
    }).then(() => {
      this.salvandoApresentacao = false;
      this.mensagemSucessoApresentacao = 'Nova unidade de compra cadastrada e vinculada com sucesso.';
      this.carregueApresentacoes();
    }).catch((erro: any) => {
      this.mensagemErroApresentacao = erro;
      this.salvandoApresentacao = false;
    });
  }

  private apliqueCorrespondencias(catalogo: any): void {
    const porApresentacao = new Map<number, any>();
    ((catalogo && catalogo.insumos) || []).forEach((item: any) => {
      if(Number(item.insumo && item.insumo.id) !== Number(this.insumo.id))
        return;
      (item.apresentacoes || []).forEach((apresentacao: any) =>
        porApresentacao.set(Number(apresentacao.id), {
          status: apresentacao.status,
          motivo: apresentacao.pendencia,
          vinculo: apresentacao.vinculo
        })
      );
    });
    this.apresentacoesCompra.forEach(apresentacao => {
      apresentacao.correspondencia = porApresentacao.get(Number(apresentacao.id)) || {
        status: 'PENDENTE',
        motivo: catalogo && !catalogo.fornecimento
          ? 'A filial não possui uma fábrica fornecedora ativa.'
          : 'O de/para ainda não foi configurado.',
        vinculo: null
      };
    });
  }

  novoIngrediente(){
    this.insumo.receita.ingredientes.push( {insumo: null})
  }

  removeIngrediente(i){
    let item = this.insumo.receita.ingredientes[i]

    if(!item.id){
      this.insumo.receita.ingredientes.splice(i, 1);
    } else {
      item.removido = true;
    }

  }

  onSalvar() {
    if(this.frm.valid)   this.salveInsumo();
  }

  salveInsumo(){
    if(this.salvando) return;
    if(this.insumo.fichaTecnica || this.insumo.objeto === 'ficha-tecnica'){
      const ingredientes = this.insumo.receita && this.insumo.receita.ingredientes || [];
      const incompleto = ingredientes.findIndex((item: any) => !item.insumo || !item.insumo.id);
      if(!ingredientes.length || incompleto >= 0){
        this.mensagemErro = !ingredientes.length ? 'Informe pelo menos 1 ingrediente.' :
          `Selecione o insumo do ingrediente ${incompleto + 1} da receita.`;
        this.abaSelecionada = 2;
        return;
      }
    }

    this.salvando = true;
    this.estoqueService.salveInsumo(this.monteDadosParaSalvar()).then((insumo) => {
      const novoCadastro = !this.insumo.id;
      // Reaproveita os IDs da receita e dos ingredientes persistidos no próximo salvamento.
      Object.assign(this.insumo, insumo);
      this.insumo.salvou = true;
      if(this.insumo.receita)
        this.insumo.receita.ingredientes = this.insumo.receita.ingredientes.filter((item: any) => !item.removido)

      if(novoCadastro) {
        if(!this.constantsService.insumosDaLoja.some((item: any) => Number(item.id) === Number(insumo.id)))
          this.constantsService.insumosDaLoja.push(this.insumo)
        if(this.deveExibirApresentacoes())
          this.carregueApresentacoes();
      }
      this.salvando = false;
      this.exibaMensagem('Insumo salvo com sucesso!')
     // this.fecheModal(this.insumo);
    }).catch((err) => {
      this.mensagemErro = err
      this.salvando = false;
    })
  }

  exibaMensagem(msg: string){
    this.mensagemSucesso = msg;
    setTimeout ( () => {
      delete this.mensagemSucesso ;
    }, 5000);
    if(this.frm){
      this.frm.form.markAsPristine();
      this.frm.form.markAsUntouched();
    }
  }

  onSalvarReceita() {
    if(this.frmFicha.valid)  this.salveInsumo();
  }

  alterouValorUnidade() {

  }

  alterouQuantidadeInicial(valor: number) {
    PreparadorEstoqueInicial.altereQuantidade(this.insumo.estoque, valor, this.fonteCustoInicial);
  }

  alterouCustoUnitarioInicial(valor: number) {
    this.fonteCustoInicial = 'unitario';
    PreparadorEstoqueInicial.altereUnitario(this.insumo.estoque, valor);
  }

  alterouCustoTotalInicial(valor: number) {
    this.fonteCustoInicial = 'total';
    PreparadorEstoqueInicial.altereTotal(this.insumo.estoque, valor);
  }

  quantidadeInicialPositiva(): boolean {
    return !!this.insumo.estoque && Number(this.insumo.estoque.quantidade) > 0;
  }

  custoMedioDoIngrediente(ingrediente: any): number | null {
    const custoMedio = ingrediente && ingrediente.insumo && ingrediente.insumo.estoque
      ? ingrediente.insumo.estoque.custoMedio
      : null;
    if(custoMedio === null || custoMedio === undefined || custoMedio === '')
      return null;

    const valor = Number(custoMedio);
    return Number.isFinite(valor) ? valor : null;
  }

  custoDoIngredienteNaComposicao(ingrediente: any): number | null {
    const custoMedio = this.custoMedioDoIngrediente(ingrediente);
    const quantidade = Number(ingrediente && ingrediente.quantidade);
    if(custoMedio === null || !Number.isFinite(quantidade))
      return null;

    return custoMedio * quantidade;
  }

  custoTotalDaComposicao(): number | null {
    let total = 0;
    for(const ingrediente of this.insumo.receita.ingredientes) {
      if(ingrediente.removido)
        continue;

      const custo = this.custoDoIngredienteNaComposicao(ingrediente);
      if(custo === null)
        return null;

      total += custo;
    }
    return total;
  }

  private monteDadosParaSalvar(): any {
    return PreparadorEstoqueInicial.prepareInsumo(
      this.insumo,
      this.controleCustoEstoqueAtivo,
      this.fonteCustoInicial
    );
  }

  handleFilter(value) {

  }

  obtenhaFormato(){
    return this.obtenhaFormatoDoInsumo(this.insumo)
  }

  obtenhaFormatoDoInsumo(insumo: any){
    return UnidadeMedidaUtils.obtenhaFormatoItem(insumo)
  }

  obtenhaDescricaoUnidade(insumo: any){
    return UnidadeMedidaUtils.obtenhaDescricaoUnidade(insumo)
  }

  abraModalNovoGrupo(){
    //scrollable: true
    const windowRef: DialogRef = this.dialogService.open({
      content: CadGrupoInsumoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      cssClass: 'bsModal',
      maxHeight:  window.innerHeight - 100

    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)
    windowRef.content.instance.empresa = this.empresa;

    windowRef.result.subscribe( (result: any) => {
        if(result && result.id){
          if(!this.grupos.some((grupo: any) => grupo.id === result.id))
            this.grupos.push(result)
          this.insumo.grupo = result;
        }
      },
      (a) => {      });
  }

  selecioneAba(aba){
    this.abaSelecionada = aba
  }

  escolheuTipo(tipo: any) {
    this.insumo.tipo = tipo;
    if(this.fichaTecnicaDeProdutoVenda()){
      delete this.insumo.estoque
      this.insumo.receita.rendimento = 1;
    }

  }

  gerarMovimentacao() {
    this.novaMovimentacao = { horario: new Date(), insumo: this.insumo};
  }

  fichaTecnicaDeProdutoVenda(){
    return this.insumo.tipo === this.FICHA_PRODUTO_VENDA
  }

  fichaTecnicaDeProdutoBeneficiado(){
    return this.insumo.tipo === this.FICHA_PRODUTO_BENEFICIADO
  }

  salvouMovimentacao(movimentacao: any) {
    Object.assign(this.insumo.estoque, movimentacao.insumo.estoque)
    this.insumo.salvou = true;
    this.cancelouMovimentacao();

    setTimeout(() => {
      this.telaMovimentacoes.movimentacoes.splice(0, 0, movimentacao)
    }, 500)


  }

  cancelouMovimentacao(){
    delete this.novaMovimentacao;
  }
}
